<!--
     <InlineBoxRelated
       :props="{qunits:QUnitCollection, actions:[]}"
       @update="update_qunit(data)"
     />
-->

<template>
  <div>
    <GenericExplorer
        v-if="local_filters"
        class="pt-2 pb-7"
        ref="generic_explorer"
        :filters="local_filters"
        :views="available_views(is_mobile, views_props)"
        hide_add_button
        @update="update_filters"
        @new_qunits="save_state"
        @update_qunit="update_qunit"
        :state="(qunit.inline_state || {})[tab.id]"
    />
  </div>
</template>


<style lang="scss">
 @import "@/sass/explorer.scss";
 .filter-list {
  width: 100% !important;
 }
 .smaller_heigh {
  padding: 0px !important;
 }
 .smaller_filter {
  padding-top: 0px !important;
  padding-bottom: 0px !important;

 }
</style>


<script>
 import { QFilters, get_qfilter } from '@/qunit/filters';
 import {default as QUnitAPI} from '@/api/QUnit';
 import { mapGetters, mapState } from 'vuex'
 import QUnitCollection from '@/qunit/QUnitCollection';
 import QUnit from '@/qunit/QUnit';

 export default {
   name: 'InlineBoxRelated',

   components: {
    GenericExplorer: () => import('@/components/explorer/GenericExplorer'),
},

   props: {
     qunits: {required: true},
     pk: {},
     qunit: {},
     props: {required: true},
     is_mobile: {type: Boolean, default: false},
     tab: {},
   },

   data: () => ({
     local_filters: null,//new QFilters(),
     qunit_clicked: null,
     header_filter_dialog: false,
     views_props: {
        'ExplorerTable': {
        },
        'ExplorerCard': {
        },
        
      },
      current_state: null,
      bp_blacklist: ['NOTIF_'],
   }),

   computed: {
     ...mapGetters(['centro_id']),
     ...mapState(['bpmap',]),

     bp_types() {
      return Object.values(this.bpmap._bps)
              .filter(it => !this.bp_blacklist.some(bp => it.id.startsWith(bp)))
              .map(it => ([it.reference,it.name]))
              .toSorted((a,b) => a[1].localeCompare(b[1]))
     },

     current_actions() {
      let actions = JSON.parse(JSON.stringify(this.props)).actions
      actions.splice(1, 0, 'ActionViewQUnit');
      return actions
    },

    allow_navigate() {
      return this.props.allow_navigate === undefined ? true : this.props.allow_navigate
    },

     common_props() {
        return {
        'actions': true,
        'navigate': this.allow_navigate,
        'filter_list': [
          'SuperFilters',
        ],
        'filter_props' : {
          'SuperFilters' : {
            'filter_list': [
              'FilterProcess',
              'FilterSearch',
              'FilterDatesRange',
              this.local_filters.get_filter_value('business_process') ? 'AdvancedFilter' : 'FilterList',
            ],
            'filter_props' : {
              'FilterProcess' : {
                'activator_class' : 'filter-list explorer-table-searchable-text',
              },
              'FilterSearch' : {
                'activator_class' : 'filter-list explorer-table-searchable-text',
              },
              'FilterDatesRange' : {
                'activator_class' : 'filter-list component explorer-table-searchable-text',
              },
              'AdvancedFilter' : {
                'activator_class' : 'filter-list component explorer-table-searchable-text',
              },
              //
              // TODO: If some day we can perform to show only available Bp's
              // then we could use this. From now they said it's not a good idea
              //
              // 'FilterList' : {
              //   'filter_list': [{
              //     cols: 12,
              //     component: "AutocompleteSelect",
              //     disabled: false,
              //     empty_value: null,
              //     hidden: null,
              //     id: "business_process_include",
              //     items: this.bp_types,
              //     label: this.$vuetify.lang.translator("filters.type"),
              //     multiple: true,
              //     value: this.local_filters.get_filter_value('business_process_include'),
              //   }],
              // },
            }
          },
        },
        'header_props': {
          'hide_divider': true,
          'hide_tabs': true,
          'hide_title': true,
          'header_class': 'smaller_heigh',
          'header_filter_class': 'smaller_filter',
        }
      }
      },
   },

   mounted() {
    this.local_filters = new QFilters();
    this.qunit_selected();
    this.local_filters.set_filter(get_qfilter('page',1));
    this.local_filters.set_filter(get_qfilter('centro',this.centro_id));
    this.local_filters.set_filter(get_qfilter('pk',this.pk));

    if (this.props.filter) {
      this.local_filters.set_filter(get_qfilter('business_process', this.props.filter))
    }
    if (this.props.filter_include) {
      this.local_filters.set_filter(get_qfilter('business_process_include', this.props.filter_include))
    }
    if (this.props.filter_exclude) {
      this.local_filters.set_filter(get_qfilter('business_process_exclude', this.props.filter_exclude))
    }

    const sort_by = "current_workflow_limit" // Default. this should be defined into BP inline definition
    
    if (this.qunits) {
      const sort_by = this.qunits.columns.findIndex(it => it.value == "current_workflow_limit") > 0 
                                    ? "current_workflow_limit" 
                                    : (this.qunits.columns[0] || {}).name
    }
    this.local_filters.set_filter(get_qfilter('sort_by', sort_by))
    this.update_filters(this.local_filters);
   },

   updated() {
    //Mobile views not updating the selected qunit after transition
    this.qunit_selected();
   },


   methods: {
    async current_qunits(filters,cancel_token) {
      return await QUnitAPI.getRelated(filters,cancel_token).then(data => {
        return new QUnitCollection({...data, labels:this.qunits.columns});

      })
    },

    available_views(is_mobile, props) {
      let view = {
        ...this.common_props,
        'function': this.current_qunits,
        'action_list': this.current_actions,
      }
      view = {...view,name: 'ExplorerTable',...props['ExplorerTable']}
      if (is_mobile) {
        view = {...view,name: 'ExplorerCard',...props['ExplorerCard']}
      }
      let views = [view];
      return views;
    },

    update_filters(filters) {
      //TODO: clear this line, local_filters no loger are send with the request
      //this.local_filters = this.local_filters.merge(filters);
    },

     update_qunit(data) {
       this.$emit('update', data);
       this.$nextTick(() => {
         this.qunit_selected();
       });
     },

     update_selected(selected) {
      this.update_filters(new QFilters(get_qfilter('business_process_include', selected)));
     },

     qunit_selected() {
      /*if (this.pk) {
        const view_ref = this.is_mobile ? 'card' : 'table';
        let view_state = this.$refs[view_ref].export_state();
        view_state.selected = [this.pk]
        this.$refs[view_ref].import_state(view_state);
      }*/
     },

     save_state(){
      if (this.$refs.generic_explorer) {
        this.current_state = this.$refs.generic_explorer.export_state();
        this.update_local_unit()
      }
     },

     update_local_unit() {
      // Get inlines states before create a copy, QUnit doesn't have inline_states as default atribute
      let inlines = this.qunit.inline_state || {}; 
      let unit = new QUnit(this.qunit)

      unit.inline_state = inlines;
      if (this.current_state) {
        unit.inline_state[this.tab.id] = this.current_state;
      } else if (this.$refs.generic_explorer) {
        unit.inline_state[this.tab.id]= this.$refs.generic_explorer.export_state();
      }

      this.$emit('local_update',unit)
     },
   },
 }
</script>
